import { type WebConfig } from "@koala/sdk";

/** Has the brand chosen Koala IDs and Brand (Olo/Chowly) IDs for their Location URLs. */
export function supportsBrandId(config: WebConfig) {
  return config.locations.location_id_source === "brand_id";
}
